import { render, staticRenderFns } from "./CatalogProductSettingSample.vue?vue&type=template&id=ce3c6d32&scoped=true&"
import script from "./CatalogProductSettingSample.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingSample.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingSample.vue?vue&type=style&index=0&id=ce3c6d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3c6d32",
  null
  
)

export default component.exports